import { useState, useEffect } from "react";
import { X, Sparkles, Users, Rocket } from "lucide-react";
import { Button } from "./ui/button";

const WelcomePopup = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check on mount
    if (localStorage.getItem("aixtribe_show_welcome") === "true") {
      setTimeout(() => setShow(true), 800);
    }
    // Listen for custom event from registration
    const handler = () => setTimeout(() => setShow(true), 800);
    window.addEventListener("aixtribe_welcome", handler);
    return () => window.removeEventListener("aixtribe_welcome", handler);
  }, []);

  const dismiss = () => {
    setShow(false);
    localStorage.removeItem("aixtribe_show_welcome");
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[100] flex items-center justify-center p-4" data-testid="welcome-popup-overlay">
      <div className="bg-[#12121A] border border-[#2A2A3A] rounded-2xl max-w-lg w-full overflow-hidden shadow-2xl animate-in fade-in zoom-in-95 duration-300" data-testid="welcome-popup">
        {/* Header with gradient accent */}
        <div className="relative px-6 pt-6 pb-4">
          <button
            onClick={dismiss}
            className="absolute top-4 right-4 text-gray-500 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/5"
            data-testid="welcome-popup-close"
          >
            <X className="w-5 h-5" />
          </button>

          <div className="flex items-center gap-4 mb-4">
            <img src="/brain-logo.png?v=4" alt="AIxTribe" className="w-14 h-14 object-contain rounded-xl shadow-lg" />
            <div>
              <p className="text-xs text-cyan-400 font-medium uppercase tracking-wider">Welcome Message</p>
              <h2 className="text-xl font-bold text-white font-heading">AIxTribe Admin</h2>
            </div>
          </div>

          <div className="h-px bg-gradient-to-r from-cyan-500/40 via-purple-500/40 to-transparent" />
        </div>

        {/* Message Content */}
        <div className="px-6 pb-6 space-y-4">
          <p className="text-white text-base leading-relaxed">
            Hey there! Welcome to <span className="text-cyan-400 font-semibold">AIxTribe</span> — we're thrilled to have you here!
          </p>

          <div className="space-y-3">
            <div className="flex items-start gap-3 p-3 rounded-xl bg-cyan-500/5 border border-cyan-500/10">
              <div className="w-8 h-8 rounded-lg bg-cyan-500/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Sparkles className="w-4 h-4 text-cyan-400" />
              </div>
              <p className="text-gray-300 text-sm leading-relaxed">
                <span className="text-white font-medium">India's 1st AI Community</span> — Connect with 10,000+ AI professionals, access 12+ AI tools, host webinars & find jobs all in one place.
              </p>
            </div>

            <div className="flex items-start gap-3 p-3 rounded-xl bg-purple-500/5 border border-purple-500/10">
              <div className="w-8 h-8 rounded-lg bg-purple-500/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Rocket className="w-4 h-4 text-purple-400" />
              </div>
              <p className="text-gray-300 text-sm leading-relaxed">
                <span className="text-white font-medium">Grow Your Career</span> — Use AI Workspace tools, take courses, earn certificates & build your portfolio to stand out in the AI industry.
              </p>
            </div>

            <div className="flex items-start gap-3 p-3 rounded-xl bg-emerald-500/5 border border-emerald-500/10">
              <div className="w-8 h-8 rounded-lg bg-emerald-500/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Users className="w-4 h-4 text-emerald-400" />
              </div>
              <p className="text-gray-300 text-sm leading-relaxed">
                <span className="text-white font-medium">Get More Followers</span> — Post daily, share your AI builds, join communities, speak at events & refer friends to earn coins.
              </p>
            </div>
          </div>

          <Button
            onClick={dismiss}
            className="w-full h-12 gradient-cyan-purple text-white font-bold text-base rounded-xl btn-glow mt-2"
            data-testid="welcome-popup-start-btn"
          >
            Let's Get Started!
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WelcomePopup;
